import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const BlockHolidayPopUp = (props) => {
  const [dateFrom, setDateFrom] = useState(
    props.mode === "edit" ? props.holiday.date_from : ""
  );
  const [dateTo, setDateTo] = useState(
    props.mode === "edit" ? props.holiday.date_to : ""
  );
  const [user, setUser] = useState(
    props.mode === "edit"
      ? props.holiday.user
      : props.mode === "add_user"
      ? props.user.name
      : ""
  );
  const [dates, setDates] = useState([]);
  const minDate =
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1 < 10
      ? "0" + (new Date().getMonth() + 1)
      : new Date().getMonth() + 1) +
    "-" +
    (new Date().getDate() < 10
      ? "0" + new Date().getDate()
      : new Date().getDate());
  const maxDatePre_f = new Date().setMonth(new Date().getMonth() + 4);
  const maxDatePre_f_remote = new Date().setMonth(new Date().getMonth() + 2);
  const maxDatePre = new Date(
    new Date(
      props.type === "remote" ? maxDatePre_f_remote : maxDatePre_f
    ).getFullYear(),
    new Date(
      props.type === "remote" ? maxDatePre_f_remote : maxDatePre_f
    ).getMonth(),
    0
  );
  const maxDate =
    new Date(maxDatePre).getFullYear() +
    "-" +
    (new Date(maxDatePre).getMonth() + 1 < 10
      ? "0" + (new Date(maxDatePre).getMonth() + 1)
      : new Date(maxDatePre).getMonth() + 1) +
    "-" +
    (new Date(maxDatePre).getDate() < 10
      ? "0" + new Date(maxDatePre).getDate()
      : new Date(maxDatePre).getDate());

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  const handleUserChange = (e) => {
    setUser(e.target.value);
  };

  const checkBlock = () => {
    var blocks = props.holidaysBlockData;
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom && el.date_from <= dateTo) ||
          (dateFrom >= el.date_from && dateFrom <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const checkUserTeam = (user) => {
    var user = props.users.filter((el) => el.name === user)[0];
    var bool = false;
    if (+user.urlop_zespol === +props.team) {
      bool = true;
    }
    return bool;
  };

  const checkOthersHolidays = () => {
    var blocks = props.holidaysData.filter((el) => checkUserTeam(el.user));
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom &&
            el.date_from <= dateTo &&
            el.type === "holiday") ||
          (dateFrom >= el.date_from &&
            dateFrom <= el.date_to &&
            el.type === "holiday")
        ) {
          count.push(el);
        }
      });
    }
    if (count.length >= 2) {
      bool = true;
    }

    return bool;
  };

  const checkSameHolidays = () => {
    var blocks = props.holidaysData;
    var bool = false;
    var emp = +props.user.urlopyAdmin === 1 ? user : props.user.name;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          ((el.date_from >= dateFrom && el.date_from <= dateTo) ||
            (dateFrom >= el.date_from && dateFrom <= el.date_to)) &&
          emp === el.user
        ) {
          count.push(el);
        }
      });
    }
    if (count.length > 0) {
      bool = true;
    }

    return bool;
  };

  const checkSameHolidaysEdit = (id) => {
    var blocks = props.holidaysData;
    var bool = false;
    var emp = +props.user.urlopyAdmin === 1 ? user : props.user.name;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          ((el.date_from >= dateFrom && el.date_from <= dateTo) ||
            (dateFrom >= el.date_from && dateFrom <= el.date_to)) &&
          emp === el.user &&
          el.id !== id
        ) {
          count.push(el);
        }
      });
    }
    if (count.length > 0) {
      bool = true;
    }

    return bool;
  };

  const checkSameHolidaysRemote = (date) => {
    var blocks = props.holidaysData;
    var bool = false;
    var emp = +props.user.urlopyAdmin === 1 ? user : props.user.name;
    if (blocks.length === 0) {
      return bool;
    } else {
      var count = [];
      blocks.map((el) => {
        if (
          new Date(date) >= new Date(el.date_from) &&
          new Date(date) <= new Date(el.date_to) &&
          emp === el.user
        ) {
          count.push(el);
        }
      });
    }
    if (count.length > 0) {
      bool = true;
    }

    return bool;
  };

  const validateBlock = () => {
    var check_user = props.mode === "add_user" ? true : user.length > 0;
    if (props.type === "remote" && props.mode !== "edit") {
      if (dates.length > 0 && check_user) {
        return true;
      }
    } else if (props.type === "remote" && props.mode === "edit") {
      if (
        dateFrom.length > 0 &&
        dateTo.length > 0 &&
        check_user &&
        new Date(dateTo) >= new Date(dateFrom)
      ) {
        return true;
      }
    } else {
      if (
        dateFrom.length > 0 &&
        dateTo.length > 0 &&
        check_user &&
        new Date(dateTo) >= new Date(dateFrom)
      ) {
        return true;
      }
    }
    return false;
  };

  const editHoliday = async (e) => {
    if (validateBlock()) {
      if (+props.user.urlopyAdmin === 1 ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (+props.user.urlopyAdmin === 1 ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          if (checkSameHolidaysEdit(props.holiday.id)) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już urlop w tym samym zakresie dat",
            });
          } else {
            var body = {
              date_from: dateFrom,
              date_to: dateTo,
              user: user,
              id: props.holiday.id,
            };

            await fetch("https://apidevkppp.ftpeople.pl/editHoliday", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Zmieniono",
              text:
                props.type === "holiday"
                  ? "wniosek urlopowy"
                  : props.type === "sick"
                  ? "zwolnienie chorobowe"
                  : props.type === "remote"
                  ? "pracę zdalną"
                  : "",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editRemote = async (e) => {
    if (validateBlock()) {
      if (+props.user.urlopyAdmin === 1 ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (+props.user.urlopyAdmin === 1 ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          if (checkSameHolidaysEdit(props.holiday.id)) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już praca zdalna w tym samym zakresie dat",
            });
          } else {
            var body = {
              date_from: dateFrom,
              date_to: dateTo,
              user: user,
              id: props.holiday.id,
            };

            await fetch("https://apidevkppp.ftpeople.pl/editHoliday", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Zmieniono",
              text:
                props.type === "holiday"
                  ? "wniosek urlopowy"
                  : props.type === "sick"
                  ? "zwolnienie chorobowe"
                  : props.type === "remote"
                  ? "pracę zdalną"
                  : "",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addHoliday = async (e) => {
    if (validateBlock()) {
      if (+props.user.urlopyAdmin === 1 ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (+props.user.urlopyAdmin === 1 ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          if (checkSameHolidays()) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już urlop w tym samym zakresie dat",
            });
          } else {
            var body = {
              date_from: dateFrom,
              date_to: dateTo,
              user: user,
              status: "ACCEPTED",
              date_added: new Date(),
              date_accepted: new Date(),
              type: props.type,
            };

            await fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text:
                props.type === "holiday"
                  ? "wniosek urlopowy"
                  : props.type === "sick"
                  ? "zwolnienie chorobowe"
                  : props.type === "remote"
                  ? "pracę zdalną"
                  : "",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addRemote = async (e) => {
    if (validateBlock()) {
      if (+props.user.urlopyAdmin === 1 ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (+props.user.urlopyAdmin === 1 ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          var checkSame = false;
          dates.map((el) => {
            checkSame = checkSameHolidaysRemote(el);
          });
          if (checkSame) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już praca zdalna w tym samym zakresie dat",
            });
          } else {
            var arr = [];
            dates.map(async (el) => {
              var body = {
                date_from: el,
                date_to: el,
                user: user,
                status: "REPORTED",
                date_added: new Date(),
                date_accepted: new Date(),
                type: props.type,
              };

              await fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});
            });

            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text:
                props.type === "holiday"
                  ? "wniosek urlopowy"
                  : props.type === "sick"
                  ? "zwolnienie chorobowe"
                  : props.type === "remote"
                  ? "pracę zdalną"
                  : "",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const addHolidayUser = async (e) => {
    if (validateBlock()) {
      if (props.type === "remote" ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (props.type === "remote" ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          if (checkSameHolidays()) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już urlop w tym samym zakresie dat",
            });
          } else {
            var body = {
              date_from: dateFrom,
              date_to: dateTo,
              user: user,
              status: props.type === "remote" ? "REPORTED" : "REPORTED",
              date_added: new Date(),
              date_accepted: props.type === "remote" ? new Date() : "",
              type: props.type,
            };

            await fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text:
                props.type === "remote" ? "pracę zdalną" : "wniosek urlopowy",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const getId = () => {
    return new Date().valueOf();
  };

  const addRemoteUser = async (e) => {
    if (validateBlock()) {
      if (props.type === "remote" ? false : checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data urlopu",
          text: "przypada w okresie blokady",
        });
      } else {
        if (props.type === "remote" ? false : checkOthersHolidays()) {
          MySwal.fire({
            icon: "error",
            title: "Inni członkowie",
            text: "zespołu przebywają w tym czasie na urlopie",
          });
        } else {
          var checkSame = false;
          dates.map((el) => {
            checkSame = checkSameHolidaysRemote(el);
          });
          if (checkSame) {
            MySwal.fire({
              icon: "error",
              title: "Istnieje",
              text: "już praca zdalna w tym samym zakresie dat",
            });
          } else {
            var arr = [];
            dates.map(async (el) => {
              var body = {
                date_from: el,
                date_to: el,
                user: user,
                status: props.type === "remote" ? "ACCEPTED" : "REPORTED",
                date_added: new Date(),
                date_accepted: props.type === "remote" ? new Date() : "",
                type: props.type,
              };

              await fetch("https://apidevkppp.ftpeople.pl/addHoliday", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});
            });

            MySwal.fire({
              icon: "success",
              title: "Dodano",
              text:
                props.type === "remote" ? "pracę zdalną" : "wniosek urlopowy",
            }).then((result) => {
              props.close();
            });
          }
        }
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const handleDatesChange = (e) => {
    var arr = [];
    if (e.length > 0) {
      e.map((el) => {
        arr.push(
          el.year +
            "-" +
            (el.month.number.length > 1
              ? el.month.number
              : "0" + el.month.number) +
            "-" +
            (el.day > 9 ? el.day : "0" + el.day)
        );
      });
    }
    setDates(arr);
  };

  return (
    <>
      <div className="mainContainerBlockPopUp">
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        {props.user.urlopyAdmin !== 1 ? (
          <div className="addH_alert">
            {props.type === "ekwiwalent" ? (
              ""
            ) : props.type === "sick" || props.type === "holiday" ? (
              <>
                O{" "}
                {props.type === "holiday"
                  ? "urlop"
                  : props.type === "sick"
                  ? "chorobowe"
                  : props.type === "remote"
                  ? "pracę zdalną"
                  : ""}{" "}
                można wnioskować z maksymalnie{" "}
                {props.type === "holiday"
                  ? "3"
                  : props.type === "sick"
                  ? "3"
                  : props.type === "remote"
                  ? "1"
                  : ""}
                -miesięcznym wyprzedzeniem.
              </>
            ) : (
              <>
                Pracę zdalną można zgłaszać z maksymalnie 1-miesięcznym
                wyprzedzeniem.
              </>
            )}
          </div>
        ) : (
          ""
        )}
        {+props.user.urlopyAdmin === 1 ? (
          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Pracownik <span className="requiredStar">*</span>
              </label>
              <select
                type="date"
                id="name"
                name="name"
                value={user}
                onChange={handleUserChange}
              >
                {props.users.map((el) => (
                  <>
                    {props.type === "remote" && +el.urlopyZdalna === 1 ? (
                      <option key={el.login} value={el.name}>
                        {el.name}
                      </option>
                    ) : (
                      ""
                    )}
                    {props.type === "ekwiwalent" ? (
                      <option key={el.login} value={el.name}>
                        {el.name}
                      </option>
                    ) : (
                      ""
                    )}
                    {props.type === "holiday" || props.type === "sick" ? (
                      <option key={el.login} value={el.name}>
                        {el.name}
                      </option>
                    ) : (
                      ""
                    )}
                  </>
                ))}
              </select>
            </div>
          </div>
        ) : (
          ""
        )}
        {props.type === "remote" && props.mode !== "edit" ? (
          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Dni pracy zdalnej <span className="requiredStar">*</span>
              </label>
              <DatePicker
                multiple
                value={dates}
                onChange={handleDatesChange}
                minDate={+props.user.urlopyAdmin === 1 ? "" : minDate}
                maxDate={+props.user.urlopyAdmin === 1 ? "" : maxDate}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        {props.type !== "remote" && props.mode !== "edit" ? (
          <>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data rozpoczęcia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : minDate}
                  max={+props.user.urlopyAdmin === 1 ? "" : maxDate}
                  value={dateFrom}
                  onChange={handleDateFromChange}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data zakończenia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : minDate}
                  max={+props.user.urlopyAdmin == 1 ? "" : maxDate}
                  value={dateTo}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {props.type === "remote" && props.mode === "edit" ? (
          <>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data rozpoczęcia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : minDate}
                  max={+props.user.urlopyAdmin === 1 ? "" : maxDate}
                  value={dateFrom}
                  onChange={handleDateFromChange}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data zakończenia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : maxDate}
                  value={dateTo}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {(props.type === "sick" ||
          props.type === "holiday" ||
          props.type === "ekwiwalent") &&
        props.mode === "edit" ? (
          <>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data rozpoczęcia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : props.type === "ekwiwalent"
                    ? "ekwiwalentu"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : minDate}
                  max={+props.user.urlopyAdmin === 1 ? "" : maxDate}
                  value={dateFrom}
                  onChange={handleDateFromChange}
                />
              </div>
            </div>
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Data zakończenia{" "}
                  {props.type === "holiday"
                    ? "urlopu"
                    : props.type === "sick"
                    ? "chorobowego"
                    : props.type === "remote"
                    ? "pracy zdalnej"
                    : ""}{" "}
                  <span className="requiredStar">*</span>
                </label>
                <input
                  type="date"
                  id="name"
                  name="name"
                  min={+props.user.urlopyAdmin === 1 ? "" : minDate}
                  max={+props.user.urlopyAdmin === 1 ? "" : maxDate}
                  value={dateTo}
                  onChange={handleDateToChange}
                />
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        <div className="saveBoxAP">
          {props.type !== "remote" ? (
            <button
              className="paymentMenuButton"
              onClick={
                props.mode === "edit"
                  ? editHoliday
                  : props.mode === "add_user"
                  ? addHolidayUser
                  : addHoliday
              }
            >
              zapisz
            </button>
          ) : (
            <button
              className="paymentMenuButton"
              onClick={
                props.mode === "edit"
                  ? editRemote
                  : props.mode === "add_user"
                  ? addRemoteUser
                  : addRemote
              }
            >
              zapisz
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default BlockHolidayPopUp;
